import React from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./MonthlyDeals.scss";
import { IData } from "features/offers/offers.interface";
import { DirectionCheck } from "utils/classnameSwitch";
import OfferCard from "../../OfferCard/OfferCard";

const MonthlyDealsCarousel: React.FC<IData> = ({
  offers
}) => {
  const { t } = useTranslation();
  const basicSetting = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
  };

  let carouselSettings = {};
  if (!offers.length)
    return null;
  else if (offers.length === 1) {
    carouselSettings = {
      ...basicSetting,
      slidesToShow: 1
    };
  }
  else if (offers.length === 2) {
    carouselSettings = {
      ...basicSetting,
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    };
  }
  else {
    carouselSettings = {
      ...basicSetting,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    };
  }
  
  return (
    <>
      <h3 className="layout-grid offer-sections-header" dir={DirectionCheck()}>
        {t('offers.monthlyDeal')}
      </h3>
      <div className="monthly-deal-wrapper" dir={DirectionCheck()}>
        <div className={`monthly-layout-grid ${offers.length === 1 ? 'single-card-align' : ''} ${offers.length === 2 ? 'two-card-align ' : 'multiple-cards'}`}>
          <Slider {...carouselSettings}>
            {offers.map((data, key) => {
              return <OfferCard data={data} variant="monthly-deal" key={key} />;
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default MonthlyDealsCarousel;
